import dynamic from "next/dynamic";

export const JobSearchForm = dynamic(() => import("./component"));
